import {delayed} from '../browser/execution';
import {isArray} from '../lang/is';
import {get} from '../lang/object';
import {updated} from './query';

const
    prefix = '__rw_cb_',
    serial = (
        (count => (
            () => count += 1))(
                0));

export default (src, options) => (
    new Promise((resolve, reject) => {
        const
            script = document.createElement('script'),
            first = document.getElementsByTagName('script')[0],
            timeout = get(options, 'timeout'),
            callback = get(options, 'callback'),
            global = get(options, 'global'),
            attrs = get(options, 'attrs'),
            finish = () => {
                if (cancel) {
                    cancel();
                }
                if (cleanup) {
                    cleanup();
                }
            };
        let loaded = false,
            cancel = null,
            cleanup = null;

        if (attrs) {
            Object.assign(script, attrs);
        }
        if (callback) {
            const
                name = `${prefix}${serial()}`;

            src = updated(src, {[callback]: name});
            window[name] = () => {
                if (!loaded) {
                    loaded = true;
                    finish();
                    resolve(
                        global &&
                        get(window, ...isArray(global) ? global : [global]));
                }
            };
            cleanup = () => {
                delete window[name];
            };
        } else {
            script.onload = script.onreadystatechange = function() {
                const state = this.readyState;

                if (!loaded && (!state || state === 'complete' || state === 'loaded')) {
                    loaded = true;
                    finish();
                    resolve(
                        global &&
                        get(window, ...isArray(global) ? global : [global]));
                }
            };
        }
        script.onerror = script.onabort = () => {
            if (!loaded) {
                loaded = true;
                finish();
                reject();
            }
        };
        if (timeout) {
            cancel = (
                delayed(
                    () => {
                        if (!loaded) {
                            loaded = true;
                            finish();
                            reject();
                        }
                    },
                    timeout));
        }
        script.async = 'async';
        script.src = src;
        first.parentNode.insertBefore(script, first);
    }));
